import React from "react";
import styled from "styled-components";

export default ({
  children,
  highlight = false,
  marker = "\\2022",
  ...props
}) => {
  let ListItem = styled.li`
    margin-bottom: 0.5em;
  `;
  let ListItemHighlight = styled.li`
    color: #393a3488;
    margin-bottom: 0.5em;

    ::marker {
      color: #393a34;
    }

    b,
    strong {
      color: #393a34;
    }
  `;

  if (!!marker) {
    ListItem = styled(ListItem)`
      ::marker {
        content: "${marker}  ";
      }
    `;
    ListItemHighlight = styled(ListItemHighlight)`
      ::marker {
        content: "${marker}  ";
      }
    `;
  }

  return highlight ? (
    <ListItemHighlight {...props}>{children}</ListItemHighlight>
  ) : (
    <ListItem {...props}>{children}</ListItem>
  );
};
